export const INVALID_MOBILE = 'INVALID_MOBILE';
export const INVITATION_CODE_SUBMITTED = 'INVITATION_CODE_SUBMITTED';
export const INVITATION_CODE_FAILED = 'INVITATION_CODE_FAILED';
export const INVITATION_CODE_SUCCESS = 'INVITATION_CODE_SUCCESS';
export const REGISTRATION_SUBMITTED = 'REGISTRATION_SUBMITTED';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
export const USERNAME_ALREADY_EXISTS = 'USERNAME_ALREADY_EXISTS';
export const UNHANDLED_REGISTRATION_ERROR = 'UNHANDLED_REGISTRATION_ERROR';
